import { Component, Input, OnInit } from '@angular/core';
import { BreadcrumbBuilder } from './breadcrumb-builder';
import { CampaignEntityService } from '../../../module/campaign-util/shared/campaign-entity';

@Component({
  selector: 'breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrls: [ './breadcrumb.component.scss' ]
})

export class BreadcrumbComponent implements OnInit {

  campaign: any = {};
  @Input() items: any[] = [];
  @Input() loadCampaign: boolean = false;

  constructor(private breadcrumbBuilder: BreadcrumbBuilder,
              private campaignEntity: CampaignEntityService) {
  }

  ngOnInit() {
    if (this.loadCampaign) {
      this.campaignEntity.getCampaign()
        .subscribe((campaign: any) => {
          this.campaign = campaign;
        }, (e) => {
          console.log(e);
        });
    }

    this.breadcrumbBuilder.eventEmitter.subscribe(
      (event: { type: string, item?: any }) => {
        switch (event.type) {
          case 'add':
            this.items.push(event.item);
            break;
          case 'clear':
            this.items = [];
            break;
        }
      }
    );
  }

}
